import React, { useEffect, useState } from "react";
import { MAPBOX_ACCESS_TOKEN, MAPBOX_CONFIG } from './mapboxConfig.js';

const AddressToGPSInput = ({ savedValue, onCoordinatesChange }) => {
    const [address, setAddress] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setAddress(savedValue || '');
    }, [savedValue]);

    const geocodeAddressWithMapbox = async (address) => {
        try {
            // Mapbox Geocoding API v6 endpoint
            const response = await fetch(
                `${MAPBOX_CONFIG.geocoding.v6}?q=${encodeURIComponent(address)}&access_token=${MAPBOX_ACCESS_TOKEN}&limit=1`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.features && data.features.length > 0) {
                const feature = data.features[0];
                const [lng, lat] = feature.geometry.coordinates;

                return {
                    lat: lat,
                    lng: lng,
                    formatted: feature.properties.full_address || feature.properties.name
                };
            }
            return null;
        } catch (error) {
            console.error('Mapbox v6 geocoding error:', error);

            // Fallback to v5 API if v6 fails
            try {
                const response = await fetch(
                    `${MAPBOX_CONFIG.geocoding.v5}/${encodeURIComponent(address)}.json?access_token=${MAPBOX_ACCESS_TOKEN}&limit=1`
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();

                if (data.features && data.features.length > 0) {
                    const feature = data.features[0];
                    const [lng, lat] = feature.center;

                    return {
                        lat: lat,
                        lng: lng,
                        formatted: feature.place_name
                    };
                }
                return null;
            } catch (fallbackError) {
                console.error('Mapbox v5 geocoding fallback error:', fallbackError);
                return null;
            }
        }
    };

    const handleGeocode = async () => {
        if (!address || !address.trim()) {
            console.log('No address provided');
            return;
        }

        console.log('Geocoding address with Mapbox:', address);

        setLoading(true);
        try {
            const coords = await geocodeAddressWithMapbox(address);

            if (coords) {
                const coordString = `${coords.lat}, ${coords.lng}`;
                onCoordinatesChange(address, coordString);
            } else {
                alert('Address not found');
            }
        } catch (error) {
            console.error('Geocoding failed:', error);
            alert('Geocoding failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex gap-2">
            <input
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Enter an address..."
                className="flex-1 px-3 py-2 border rounded-lg"
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent form submission
                        handleGeocode();
                    }
                }}
            />
            <button
                type="button"
                onClick={handleGeocode}
                disabled={loading || !address?.trim()}
                className="w-10 h-10 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 flex items-center justify-center"
                title="Geocode with Mapbox"
            >
                {loading ? '...' : '📍'}
            </button>
        </div>
    );
};

export default AddressToGPSInput;